<template>
  <div class="page-my-audio"
       :class="[
         { 'is-hide-tab': !render.showVipAudioTab },
       ]"
  >
    <ym-tabs v-model="tabSelected">
      <ym-tab name="paidAudio"
              title="已购音频"
      >
        <ym-loadmore v-model="paidAudio.loading"
                     :finished="paidAudio.allLoad"
                     @load="fetchData"
        >
          <audio-list :list="paidAudio.list"
                      :show-empty="paidAudio.allLoad"
          />
        </ym-loadmore>
      </ym-tab>

      <ym-tab name="vipAudio"
              title="会员音频"
              v-if="render.showVipAudioTab"
      >
        <template #title>
          <ym-img class="vip-icon"
                  :src="require('@/assets/img/vip/vip_square_medium_icon.png')"
                  alt=""
          />
          会员音频
        </template>

        <vip-audio-list :list="vipAudio.list" />
      </ym-tab>
    </ym-tabs>
  </div>
</template>

<script>
  import { Tabs, Tab, Loadmore } from '@ymba/ym-ui';
  import AudioList from '@/pages/Audio/components/AudioList';
  import VipAudioList from '@/pages/My/components/VipAudioList';
  import { getMyAudio } from '@/services/user';
  import { getMyVipAudioList } from '@/services/vip';
  import { LIMIT } from '@/utils/constant';

  export default {
    name: 'PageMyAudio',
    metaInfo: {
      title: '音频课程',
    },
    components: {
      'ym-loadmore': Loadmore,
      'ym-tabs': Tabs,
      'ym-tab': Tab,
      AudioList,
      VipAudioList,
    },
    data() {
      return {
        tabSelected: 'paidAudio',
        paidAudio: {
          type: 'paidAudio',
          start: 0,
          list: [],
          allLoad: false,
          loading: false,
        },
        vipAudio: {
          type: 'vipAudio',
          list: [],
        },
        render: {
          showVipAudioTab: false,
        },
      };
    },
    computed: {
      type() {
        return this.$route.query && this.$route.query.type ? this.$route.query.type : '';
      },
    },
    methods: {
      async fetchData(isLoadMore = true) {
        if (this.paidAudio.allLoad) return;
        this.paidAudio.loading = true;

        const data = await getMyAudio({
          limit: LIMIT,
          start: this.paidAudio.start,
          type: this.type,
        }, isLoadMore);

        this.render = data.render;

        if (data.list.length === 0) {
          this.paidAudio.allLoad = true;
          this.paidAudio.loading = false;
          return;
        }

        this.paidAudio.start = data.start;
        const { list } = data;
        this.paidAudio.list = [...this.paidAudio.list, ...list];

        this.paidAudio.loading = false;
      },
      async fetchVipAudioData() {
        const data = await getMyVipAudioList();
        this.vipAudio.list = data.productList;
      },
    },
    created() {
      this.fetchData(false);
      this.fetchVipAudioData();
    },
    beforeRouteUpdate(to, from, next) {
      this.fetchData(false);
      this.fetchVipAudioData();
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-my-audio {
    height: 100%;
    background-color: @color-white;

    &.is-hide-tab {
      margin-top: -80px;
    }
  }

  .vip-icon {
    display: block;
    width: 60px;
    height: 30px;
    margin-right: @size-extra-small;
  }
</style>
